import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  notFoundValue: {
    color: theme.palette.error.dark,
  },
}));

export default useStyles;
